import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { Loader } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './billing.scss';

// Components
import { BillingTotal } from './children/billing-total/billing-total';

// Store entities
import { fetchBillingBalance } from '../../../../store/billing/billing.thunks';
import { getBillingState } from '../../../../store/billing/billing.selectors';

type TBillingProps = {};

export const Billing: FC<TBillingProps> = (
  {}: TBillingProps
) => {
  const { balance, loading } = useSelector(getBillingState);

  const dispatch = useDispatch<any>();

  const loadBillingBalance = (): void => {
    dispatch(fetchBillingBalance());
  }

  useEffect(() => {
    loadBillingBalance();
  }, []);

  return (
    <div className="billing">
      <div className="billing--header">
        <div className="header-title">
          Billing
        </div>
      </div>

      <div className="billing--body">
        <div className="body-column">
          <div className="body-column--title">
            Minutes Balance
          </div>
          <div className="body-column--description">
            <p>Seconds to insight! Free trial minutes unlock instant connections with your Consultants for paid Voice and Video consultations.</p>
            <p>So don't miss out on your free minutes! </p>
          </div>
          <div className="body-column--total">
            { loading && <Loader size={ 'large' }/> }
            { !loading && <BillingTotal hint={ 'Minutes' } total={ balance.minutes }/> }
          </div>
        </div>
        <div className="body-column">
          <div className="body-column--title">
            Correspondence Balance
          </div>
          <div className="body-column--description">
            <p>Boost engagement! Free trial Requests enable clients to message Consultants for paid Text consultations.</p>
            <p>Explore additional Consultants' expertise monetization!</p>
          </div>
          <div className="body-column--total">
            { loading && <Loader size={ 'large' }/> }
            { !loading && <BillingTotal hint={ 'Requests' } total={ balance.correspondence }/> }
          </div>
        </div>
      </div>
    </div>
  );
}
